import { render, staticRenderFns } from "./Lowpricelinks.vue?vue&type=template&id=6edd3e99"
import script from "./Lowpricelinks.vue?vue&type=script&lang=js"
export * from "./Lowpricelinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports